import { useState } from 'react';
import { canvasWorkingLabels, summarizeCanvasProgress, type CanvasProgressInput } from './canvas-progress-summary';

export function ChatThinkingLabel() {
  return <><style>{`@keyframes chat-thinking-shimmer { from { background-position: 200% 0; } to { background-position: -200% 0; } }
.chat-thinking-shimmer { background: linear-gradient(90deg, #777b80 25%, #c4c7cb 50%, #777b80 75%); background-size: 200% 100%; background-clip: text; -webkit-background-clip: text; color: transparent; animation: chat-thinking-shimmer 1.8s linear infinite; }
@media (prefers-reduced-motion: reduce) { .chat-thinking-shimmer { animation: none; color: #777b80; background: none; } }`}</style><span className="chat-thinking-shimmer">Thinking…</span></>;
}

/** Disclosure state belongs to the reader, even while new details arrive. */
export function ThinkingBlock({ msgId, progress, isStreaming }: { msgId: string; progress: CanvasProgressInput; isStreaming: boolean }) {
  const [open, setOpen] = useState(false);
  const text = summarizeCanvasProgress(progress, isStreaming).join('\n');
  return <div data-testid={`classifier-reasoning-${msgId}`} style={{ marginBottom: 12 }}>
    <button aria-expanded={open} aria-controls={`thinking-details-${msgId}`} onClick={() => setOpen(value => !value)}
      style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'none', border: 'none', padding: '2px 0', cursor: 'pointer', color: '#777b80', font: 'inherit', fontSize: 13, fontWeight: 500 }}>
      <span aria-hidden="true" style={{ display: 'inline-block', fontSize: 10, transform: open ? 'rotate(90deg)' : 'none' }}>▶</span>
      {isStreaming ? <ChatThinkingLabel /> : 'Work details'}
    </button>
    {open && <div id={`thinking-details-${msgId}`} style={{ padding: '8px 0 0 16px', fontSize: 13, color: '#777b80', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{text}</div>}
  </div>;
}

/** Live project state is authoritative; saved unfinished cards are history. */
export function BottomStatusLine({ isTyping, progress = {} }: { isTyping: boolean; progress?: CanvasProgressInput }) {
  if (!isTyping) return null;
  return <RotatingStatus progress={progress} />;
}

function RotatingStatus({ progress }: { progress: CanvasProgressInput }) {
  const labels = canvasWorkingLabels(progress);
  return <div role="status" data-testid="chat-working-status" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', fontSize: 13, color: '#777b80' }}>
    <span aria-hidden="true"><ChatThinkingLabel /></span>
    <span className="sr-only">{labels[0]}.</span>
  </div>;
}
